// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MoneyCollectTwoToneSvg from "@ant-design/icons-svg/es/asn/MoneyCollectTwoTone";
import AntdIcon from '../components/AntdIcon';

var MoneyCollectTwoTone = function MoneyCollectTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MoneyCollectTwoToneSvg
  }));
};

MoneyCollectTwoTone.displayName = 'MoneyCollectTwoTone';
export default React.forwardRef(MoneyCollectTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MoneyCollectTwoTone.js
// module id = 1511
// module chunks = 0